import React, { useState, useEffect, lazy, Suspense} from "react";
import CacheBuster from 'react-cache-buster';
import axios from "axios";
import appversion from '../package.json';
import "@fontsource/poppins";
import MediaQuery from "react-responsive";
import Navbar from './components/Navbar';
import jsonData from "./PostEvent/ai-branding.json"; // Import the JSON file
import { useHyperlink } from "./contexts/HyperlinkProvider.js";

// const Body = lazy(() => import("./components/Body"));
// const KeyNote = lazy(() => import("./components/KeyNote"));
const Footer = lazy(() => import("./PostEvent/FooterNew/index.js"));
const EventMemories = lazy(() =>  import("./PostEvent/EventMemories/EventMemories.js"));
const EventMemoriesMobile = lazy(() =>  import("./PostEvent/EventMemories/EventMemoriesMobile.js"));
const SocialMedia = lazy(() =>  import("./PostEvent/SocialMedia/SocialMedia.js"));
const SubscribeForEventNotifications = lazy(() =>  import("./PostEvent/SubscribeForEventNotifications"));
const SignupForm = lazy(() => import("./components/SignUpForm.js"));
const Banner = lazy(() => import("./PostEvent/Banner/Banner.js"));
const ThankYou = lazy(() => import("./PostEvent/ThankYou/ThankYou.js"));

function App() {
const appVersion = appversion.version;
const [angelAiLink, setAngelAiLink] = useState("");
  const [angelComLink, setAngelComLink] = useState("");
  const [sunwestLink, setSunWestLink] = useState("");
  const [swmcLink, setSwmcLink] = useState("");
  const [celligenceLink, setCelligenceLink] = useState("");
  const [celligenceLlcLink, setCelligenceLlcLink] = useState("");
  const [pavanLink, setPavanLink] = useState("");
  const { getHyperLink } = useHyperlink();

  useEffect(() => {
    const processContent = async () => {
      const swLink = await getHyperLink("websites", "swmc", 0);
      const swmcLink = await getHyperLink("websites", "swmc", 1);
      const aiLink = await getHyperLink("websites", "angelai", 0);
      const aiComLink = await getHyperLink("websites", "angelai", 1);
      const cellLink = await getHyperLink("websites", "celligence", 1);
      const celliLlcLink = await getHyperLink("websites", "celligence", 0);
      const pavan = await getHyperLink("profiles", "pavan", 0);
      setAngelAiLink(aiLink || "AngelAi");
      setAngelComLink(aiComLink || "AngelAi.com");
      setSunWestLink(swLink || "Sun West");
      setSwmcLink(swmcLink|| "Sun West Mortgage Company, Inc.");
      setCelligenceLink(cellLink || "Celligence");
      setCelligenceLlcLink(celliLlcLink || "Celligence LLC");
      setPavanLink(pavan || "Pavan Agarwal");
    };
    processContent();
  }, [getHyperLink]);


const [links, setLinks] = useState(null);
  useEffect(() => {
    const fetchLinks = async () => {
      try {
        const response = await axios.get(process.env.REACT_APP_ANGELAI_JSON);
        setLinks(response.data);
      } catch (error) {
        console.error("Error fetching links:", error);
        setLinks(jsonData); // Use local JSON data if fetching fails
      }
    };

    if (!links) {
      fetchLinks(); // Fetch JSON only if the links data is not available
    }
  }, [links]);

  useEffect(() => {
    if (!links) {
      setLinks(jsonData); // Set local JSON data as fallback initially
    }
  }, []);
   return (
    <div className="bodyContainer">
    <CacheBuster
      currentVersion={appVersion}
      isEnabled ={true}
      isVerboseMode={false} //If true, the library writes verbose logs to console.
      metaFileDirectory={'.'}
    >
    
      {/* <img
        src={imgCDNURL + "dots-group.png"}
        className="dots-group img-fluid"
      />
      <img src={imgCDNURL + "connect-bg.webp"} className="body-bg img-fluid" />
      <Suspense fallback={<div />}> 
        <Body />
      </Suspense>
      <Suspense fallback={<div />}>
        <KeyNote />
      </Suspense> */}
      {/* The above section is commented as it is for pre-event page*/}
      {links ? (
      <>
      <Navbar />   
      <Suspense fallback={<div />}>
        <Banner links={links} sunwestLink={sunwestLink} angelAiLink={angelAiLink} pavanLink={pavanLink}/>
      </Suspense>
      <MediaQuery minWidth={993}>
        <Suspense fallback={<div />}>
          <EventMemories />
        </Suspense>
      </MediaQuery>
      {/* Renders the components of mobile and tablet view */}
      <MediaQuery maxWidth={992}>
        <Suspense fallback={<div />}>
          <EventMemoriesMobile />
        </Suspense>
      </MediaQuery>
      <Suspense fallback={<div />}>
        <SocialMedia />
      </Suspense>{" "}
      <Suspense fallback={<div />}>
        <ThankYou sunwestLink={sunwestLink} />
      </Suspense>
      <Suspense fallback={<div />}>
        <SubscribeForEventNotifications />
      </Suspense>
      <Suspense fallback={<div />}>
        <SignupForm swmcLink={swmcLink} celligenceLlcLink={celligenceLlcLink}/>
      </Suspense>
      <Suspense fallback={<div />}>
        <Footer />
      </Suspense>
      </>
       ) : (
              <div>Loading...</div>
            )}
      </CacheBuster>
    </div>
  );
}

export default App;
